import api from '../../api';

// initial state
const state = () => ({
    all: [],
    service: null,
});

// getters
const getters = {

    getById: (state) => (id) => {
        return state.all.find(item => item.id === id);
    },

};

// actions
const actions = {

    loadAll ({ commit }) {
        return api.services.getAll().then((response) => {
            commit('setAll', response.data);
        });
    },

    load ({ commit }, id) {
        return api.services.get(id).then((response) => {
            commit('set', response.data);
        });
    },

};

// mutations
const mutations = {

    setAll (state, services) {
        state.all = services;
    },

    set (state, service) {
        state.service = service;
    },

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};